module.exports = __webpack_public_path__ + "img/sample-banner.1de42aa2.png";